/**
 * Uma unidade vista como combatente: o que a fórmula de combate precisa saber.
 *
 * Havia quatro cópias desta função — nas ações, na IA, na política de
 * simulação e na tela —, e as quatro esqueciam a mesma coisa quando as
 * condições chegaram: uma unidade cega prevista pela IA como se enxergasse é
 * uma previsão que mente. Uma cópia só é o que garante que a barra de previsão,
 * a IA e o motor falem do mesmo combate.
 */
import { terrainAt } from './grid.js';
import { weaponOf } from './state.js';
export function combatantOf(state, content, unit, at = unit.position) {
    const klass = content.classes.get(unit.classId);
    return {
        stats: unit.stats,
        con: klass?.con ?? 7,
        weapon: weaponOf(content, unit),
        terrain: terrainAt(state.map, content, at),
        archetype: klass?.archetype ?? 'infantaria',
        currentHp: unit.currentHp,
        // Ausentes no caso comum: a previsão de uma unidade sem condição continua
        // idêntica, campo a campo, à de antes.
        ...(unit.states.length > 0 ? { conditions: unit.states } : {}),
        ...(unit.inflicts && unit.inflicts.length > 0 ? { inflicts: unit.inflicts } : {}),
    };
}
//# sourceMappingURL=combatant.js.map